import {
    STATESUMMARY
  } from "../api/constApi";
  import { apiInstance } from "./axiosApi";
  
  export const stateSummary = (payload) => {
    return apiInstance.post(STATESUMMARY, payload);
  };
  